import { jwtDecode } from 'jwt-decode'

import { getUserIdentity } from './auth'

// FGTAFO clients are identified server-side by a national identifier prefixed
// with "FGTAFO-" (see IdentitySerializer#is_fgtafo). We read that flag from the
// identity endpoint to decide whether to redirect them to the shop app.
// This check runs on the sign-in critical path, ahead of the redirect, so we
// cap it like isAffiliate does: a slow/hung identity endpoint must fall back to
// the default flow rather than stall the redirect for every user. A hanging
// request never rejects, so without this timeout the try/catch would not help.
const TIMEOUT = 1000

export const isFgtafo = async (accessToken: string): Promise<boolean> => {
  try {
    const { sub } = jwtDecode<{ sub?: string }>(accessToken)
    if (!sub) {
      return false
    }
    const identity = await getUserIdentity(sub, accessToken, { timeout: TIMEOUT })
    return identity.is_fgtafo === true
  } catch {
    return false
  }
}
